<script>
  import RateMaterialHeader from "./RateMaterialHeader.svelte";
  import RateMaterialRow from "./RateMaterialRow.svelte";
  import { createEventDispatcher, onMount } from "svelte";
  import { Wave } from "svelte-loading-spinners";
  import Select from "svelte-select";
  import config from "./../../../stores/config";
  import Modal from "./../../../shared/Modal.svelte";
  import * as ls from "local-storage";
  import axios from "axios";

  export let EDITABLE = false;

  const dispatch = createEventDispatcher();

  let authData = { headers: { authorization: ls.get("jwt") } };

  let K = 0;
  let plankPrice;

  function handleSelect(e) {
    material = e.detail;

    let { lotNumber, length, width, thickness, bundlePrice } = material;

    if (lotNumber) {
      let totalMM = length * width * thickness;
      K = $config.K.find((el) => el._id == lotNumber).total;
      plankPrice = Number((totalMM / K) * bundlePrice).toFixed(2);
      newMat.qtyReq = 1;
      newMat.uPrice = plankPrice;
    }
  }

  export let styleID;
  export let materialReq;
  let material;

  const emptyNewMat = {
    itemID: null,
    qtyReq: null,
    uPrice: null,
  };

  let newMat = { ...emptyNewMat };

  let showAddNewMatForm = false;
  let addNewMatLoading = false;

  $: leftItems =
    materialReq?.length > 0
      ? $config.items.filter(({ value }) =>
          materialReq.find((r) => r.itemID != value)
        )
      : $config.items;

  const handleDecrement = (qty, itemID, styleID, _id) => {
    return new Promise((resolve, reject) => {
      axios
        .put(
          `${$config.backendURL}/fstyles/decrement/${itemID}/${styleID}/${_id}`,
          { qty },
          {
            headers: { authorization: ls.get("jwt") },
          }
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          console.log(err);
          alert(err);
          reject(err);
        });
    });
  };

  const handleAddNewMat = async (e) => {
    if (!material) alert("⚠ Material name missing!");
    else if (newMat.qtyReq == undefined) alert("⚠ Quantity Required missing!");
    else {
      addNewMatLoading = true;

      let data;

      if (material?.lotNumber) {
        data = {
          ...newMat,
          itemID: material.value,
          uPrice: plankPrice,
        };
      } else {
        data = {
          ...newMat,
          itemID: material.value,
          uPrice: material.price,
        };
      }

      axios
        .put(
          `${$config.backendURL}/fstyles/${styleID}/add-material`,
          data,
          authData
        )
        .then(async (res) => {
          let curr = [...res?.data?.materialReq];
          let { _id, itemID, qtyReq } = curr.pop();

          // Check quantities here first
          let inventoryLevel = $config?.items?.find(
            ({ value }) => value == itemID
          )?.inventoryLevel;
          // Checking...
          if (inventoryLevel < qtyReq) {
            alert(
              `\n⚠ There's not enough of this row material in Stock for automatic assign.\n\nManual assignement will be used when stock is refilled.`
            );
          } else {
            // Automatic assignments here...
            await handleDecrement(qtyReq, itemID, styleID, _id);
            // ... End
          }

          showAddNewMatForm = false;
          addNewMatLoading = false;
          newMat = { ...emptyNewMat };

          setTimeout(() => {
            dispatch("reloadData");
          }, 1000);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
</script>

<Modal
  show={showAddNewMatForm}
  on:modalClose={() => {
    showAddNewMatForm = false;
  }}
>
  <div class="grid gap-y-2 pb-10">
    <div class="grid grid-cols-3 gap-2 items-center">
      <div>Select Stock Item :</div>
      <div class="col-span-2">
        <!-- HERE HERE -->
        <!-- <Select items={$config.items} on:select={handleSelect} /> -->
        <Select items={leftItems} on:select={handleSelect} />
      </div>
    </div>

    <!-- {#if material?.lotNumber == null && material?.price >= 0} -->
    <div class="grid grid-cols-3 gap-2 items-center">
      <div>Quantity Required :</div>
      <input
        class="col-span-2"
        bind:value={newMat.qtyReq}
        type="number"
        step="any"
        placeholder="Quantity required"
      />
    </div>
    <!-- {/if} -->

    {#if addNewMatLoading}
      <div class="flex items-center justify-center btn btn-primary-outline">
        <Wave size="25" color="rgb(244,162,97)" unit="px" />
        <span class="ml-4">Please wait...</span>
      </div>
    {:else}
      <!-- else content here -->
      <div class="flex">
        <button
          style="width: 100%;"
          class="btn btn-primary"
          on:click={handleAddNewMat}
        >
          <i class="fas fa-check-circle mr-3" />
          Save
        </button>
        <button
          style="width: 100%;"
          class="ml-4 btn btn-gray"
          on:click={(e) => (showAddNewMatForm = false)}
        >
          <i class="fas fa-times-circle mr-3" />
          Close
        </button>
      </div>
    {/if}
  </div>
</Modal>

{#if EDITABLE}
  <div class="grid grid-cols-1 gap-4">
    <button
      class="btn btn-primary"
      on:click={(e) => (showAddNewMatForm = true)}
      style="width: 100%;"
    >
      <i class="fas fa-plus-circle mr-3" />
      Add bill of material here
    </button>
  </div>
{/if}

{#if materialReq == null}
  <div class="loading-screen h-screen flex items-center justify-center">
    <Wave size="50" color="rgb(244,162,97)" unit="px" />
  </div>
{:else}
  <div
    class="mt-6 bg-white rounded-md shadow-sm w-full overflow-auto text-gray-500 text-sm"
  >
    <RateMaterialHeader {EDITABLE} />
    {#each materialReq as mat (mat._id)}
      <div class="">
        <RateMaterialRow
          {EDITABLE}
          {...mat}
          {styleID}
          on:delete={() => dispatch("reloadData")}
          on:update={() => dispatch("reloadData")}
        />
      </div>
    {:else}
      <div class="col-span-full">
        <div class="h-52 w-full flex items-center justify-center uppercase">
          The bill of material isn't set for this finished product...
        </div>
      </div>
    {/each}
  </div>
{/if}
